import React from 'react';
import styles from './PulsingArrow.module.css';

interface PulsingArrowProps {
  targetX: number; // percentage from left
  targetY: number; // percentage from top
  visible: boolean;
  onClick?: () => void;
}

function PulsingArrow({ targetX, targetY, visible, onClick }: PulsingArrowProps) {
  if (!visible) return null;

  return (
    <div
      className={styles.pulsingArrow}
      style={{
        left: `${targetX}%`,
        top: `${targetY}%`,
      }}
      onClick={onClick}
    >
      <div className={styles.arrowContainer}>
        <div className={styles.arrow}>▲</div>
        <div className={styles.text}>Start Here</div>
      </div>
    </div>
  );
}

export default PulsingArrow;
